import React from "react";
import { useTranslations } from "next-intl";
import { Avatar, Box, styled, useMediaQuery } from "@mui/material";
import theme from "styles/theme/theme";

const Logo = styled(Avatar)(({ theme }) => ({
  width: 440,
  height: "auto",
  objectFit: "contain",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: 340,
  },
}));

function Cover({ children }: any) {
  const translation = useTranslations("home");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        padding: "40px 0 0 0",
        marginBottom: 0,
        zIndex: 1,
        backgroundColor: "var(--color-brand-cream-primary)",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#aa9d89",
          width: "100%",
          height: { xs: 360, sm: 450 },
          borderRadius: { xs: 0, sm: "0 0 0 200px" },
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          width: { xs: "100%", sm: "85%" },
          height: { xs: 380, sm: 500, md: 600 },
          borderRadius: "60px",
          overflow: "hidden",
          display: "grid",
          justifyContent: "center",
          alignContent: "flex-start",
          paddingTop: { xs: 1, sm: 5, md: 10 },
          backgroundImage: "url('/images/image-optimize/living.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          margin: "0 auto",
          position: "relative",
          zIndex: 3,
        }}
      >
        <Box
          sx={{ marginTop: { xs: 6, sm: 4 }, marginBottom: { xs: 2, sm: 4 } }}
        >
          <Logo
            src={
              isMobile ? "/images/v2/logos/10.png" : "/images/v2/logos/9.png"
            }
            alt="Logo Re/max"
            variant="square"
          />
          <Box
            component="p"
            sx={{
              color: "white",
              fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.6rem" },
              textAlign: "center",
              fontWeight: 400,
              "& span": {
                fontFamily: "var(--font-family-extra), sans-serif",
                color: "#fff",
                fontSize: { xs: "1.2rem", sm: "1.4rem" },
                position: "relative",
                bottom: "-20px",
              },
            }}
          >
            {translation.rich("title", {
              span: (chunks) => <span>{chunks}</span>,
            })}
          </Box>
        </Box>

        {children}
      </Box>
    </Box>
  );
}

export default Cover;
